import React from "react";
import { useSearchParams } from "react-router-dom";
import { Divider, Stack, Typography } from "@mui/material";

import { HubButton, HubCardStack, PageContent } from "../../components";
import { FoundryLogo } from "../../svgs";

import ResetPasswordRequest from "./ResetPasswordRequest";
import ResetPasswordFullfillment from "./ResetPasswordFullfillment";
import { useGetPasswordTokenById } from "../../hooks";
import ResetPasswordError from "./ResetPasswordError";
import ResetPasswordSuccess from "./ResetPasswordSuccess";

const cardsx = {
  maxWidth: "600px",
  width: "100%",
  height: "fit-content",
  padding: "50px",
  gap: "50px",
  alignItems: "center",
  flexGrow: "0",
};

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const success = searchParams.get("success") === "true";
  const { isError } = useGetPasswordTokenById(token);

  return (
    <PageContent
      fullHeight
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      <HubCardStack sx={cardsx}>
        <FoundryLogo fill="#525252" size={125} />
        <Stack gap="25px" width="100%" alignItems="center">
          {success ? (
            <ResetPasswordSuccess />
          ) : token && isError ? (
            <ResetPasswordError />
          ) : (
            <>
              <Stack gap="0px" width="100%">
                <Typography variant="h3">Reset Password</Typography>
                <Typography variant="caption">
                  {token
                    ? "Please enter and confirm your new password"
                    : "Please enter the email associated to your account"}
                </Typography>
              </Stack>
              {!token ? (
                <ResetPasswordRequest />
              ) : (
                <ResetPasswordFullfillment token={token} />
              )}
            </>
          )}
          <Divider orientation="horizontal" flexItem />
          <HubButton
            variant="text"
            page="/signin"
            sx={{ padding: 0 }}
            icon="ArrowLeft"
            label="Back to Sign In"
          />
        </Stack>
      </HubCardStack>
    </PageContent>
  );
};

export default ResetPasswordPage;
